import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_user_invitation_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.WORKSPACE_USER_INVITATION_DELETE,
  payload,
});

export const init_local_workspace_user_invitation_delete = (state: STATE__workspace, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    state.invitations_map_to_other_users.delete(id);

    state.invitations_map_to_other_workspaces.delete(id);
  }

  //need refresh map to trigger re-render
  state.invitations_map_to_other_users = new Map(state.invitations_map_to_other_users);

  //need refresh map to trigger re-render
  state.invitations_map_to_other_workspaces = new Map(state.invitations_map_to_other_workspaces);
};
